/**
 * Shared auth-error classification helpers.
 */

/**
 * True when a Supabase/GoTrue auth error represents a *banned* user — i.e. an
 * account that has been deactivated (deactivation applies a GoTrue ban, see
 * `app/api/admin/users/[id]/deactivate/route.ts`).
 *
 * Matches ONLY the structural error code (`'user_banned'` in @supabase/auth-js
 * error-codes.ts). We deliberately do NOT fall back to HTTP 403: GoTrue returns
 * 403 for an *expired or invalid* email link too (code `otp_expired`, see
 * `internal/api/verify.go`), so a 403 fallback misclassifies a stale or
 * pre-fetched invite as a deactivated account and shows the alarming "Account
 * Deactivated" screen instead of a "link expired" prompt. We also do NOT
 * substring-match the message — `'ban'` would match `'banner'`, `'abandoned'`,
 * and any non-English copy change. Mirrors the ban interception in
 * `app/api/auth/verify-magic-link/route.ts`.
 */
export function isBannedAuthError(
  error: { code?: string; status?: number } | null | undefined,
): boolean {
  if (!error) return false;
  return error.code === 'user_banned';
}
